/**
 * RecordingWaveformStore
 *
 * Isolated store for live audio frequency data. Updated at ~15fps
 * during recording. Separated from the session store to avoid
 * triggering rerenders on components that don't need waveform data.
 *
 * Consumed by: RecordingMiniBar (waveform bars), RecordingActiveView
 */

import { create } from 'zustand';

interface RecordingWaveformState {
  frequencyData: Uint8Array | null;
}

interface RecordingWaveformActions {
  setFrequencyData: (data: Uint8Array | null) => void;
  reset: () => void;
}

type RecordingWaveformStore = RecordingWaveformState &
  RecordingWaveformActions;

export const useRecordingWaveformStore = create<RecordingWaveformStore>()(
  (set) => ({
    frequencyData: null,

    setFrequencyData: (data) => set({ frequencyData: data }),

    reset: () => set({ frequencyData: null })
  })
);

/** Direct getter for non-React contexts (e.g. RAF loops) */
export const setWaveformData = (data: Uint8Array | null) =>
  useRecordingWaveformStore.getState().setFrequencyData(data);

export const resetWaveform = () =>
  useRecordingWaveformStore.getState().reset();
